var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", gap: "16px" } },
    [
      _c(
        "sc-field",
        [
          _c(
            "sc-select",
            {
              model: {
                value: _vm.selectedDateSource,
                callback: function($$v) {
                  _vm.selectedDateSource = $$v
                },
                expression: "selectedDateSource"
              }
            },
            [
              _c(
                "option",
                { key: "EXPIRATION_DATE", attrs: { value: "EXPIRATION_DATE" } },
                [_vm._v("Data de vencimento")]
              ),
              _vm._v(" "),
              _c(
                "option",
                { key: "CREATION_DATE", attrs: { value: "CREATION_DATE" } },
                [_vm._v("Data de criação")]
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "sc-field",
        [
          _c("sc-range-date-picker", {
            staticStyle: { width: "300px" },
            attrs: { id: "billing-date-picker", format: _vm.formatDate },
            model: {
              value: _vm.selectedDateRange,
              callback: function($$v) {
                _vm.selectedDateRange = $$v
              },
              expression: "selectedDateRange"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "sc-field",
        { staticStyle: { width: "260px" } },
        [
          _c("sc-warehouse-dropdown", {
            attrs: {
              customPlaceholder: _vm.warehouseSelectPlaceholder,
              "list-user": "",
              dropdown: ""
            },
            on: {
              selectAll: function(values) {
                return (_vm.selectedWarehouseFilter = values)
              },
              clearFilter: function() {
                return (_vm.selectedWarehouseFilter = [])
              }
            },
            model: {
              value: _vm.selectedWarehouseFilter,
              callback: function($$v) {
                _vm.selectedWarehouseFilter = $$v
              },
              expression: "selectedWarehouseFilter"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0fff38b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fff38b3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-recon/features/billing/components/billing-filter-area/BillingFilterArea.vue
// module id = null
// module chunks = 